import { server } from "../utils/server"

const addLog = ({ mobileNumber,userId, event, listingId, projectId }) => {
  return server.get("/logs/addLogs", {
    params: { mobileNumber,userId, event, listingId, projectId }
  })
  .then((res) => res.data)
  .catch((err) => err);
};

const logsService = {
  addLog
};

export default logsService;
